import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADContainer entity - alias of ADObject
 * Represents Active Directory container objects
 */
export const adContainerEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADContainer', display: 'AD Container' },
  alias: 'ADObject',
};
